import { v4 as uuidv4 } from 'uuid'

export function randomContentId() {
  /* prettier-ignore */
  const chars = [
    'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U',
    'V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p',
    'q','r','s','t','u','v','w','x','y','z','0','1','2','3','4','5','6','7','8','9',
  ]

  let id = ''

  for (let i = 0; i < 28; i++) {
    id += chars[Math.floor(Math.random() * chars.length)]
  }
  return id
}

export function uuidImageName(imageFile) {
  return `${uuidv4()}.${imageFile.name.split('.').pop()}`
}
